import { siteTitle } from "constants/config";
import { memo } from "react";

const SmartLogo = () => (
    <>
        <div className="flex dark:hidden">
            <img src="/assets/image/logo/2-mini.png" alt={siteTitle} />
            <img src="/assets/image/logo/2.png" alt={siteTitle} />
        </div>

        <div className="hidden dark:flex">
            <img src="/assets/image/logo/1-mini.png" alt={siteTitle} />
            <img src="/assets/image/logo/1.png" alt={siteTitle} />
        </div>
    </>
)

export default memo(SmartLogo);